import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
export var PRACTICE_ASSIGNMENT_API = 'PRACTICE_ASSIGNMENT_API';
export var PracticeAssignmentApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(PracticeAssignmentApi, _AxiosApi);

  var _super = _createSuper(PracticeAssignmentApi);

  function PracticeAssignmentApi(axiosInstance) {
    var _this;

    _classCallCheck(this, PracticeAssignmentApi);

    _this = _super.call(this, 'practice-assignments', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(PracticeAssignmentApi, [{
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(practiceAssignment) {
        var url, body, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url, "/").concat(practiceAssignment.id, "/status");
                body = {
                  endTime: practiceAssignment.endTime
                };
                _context.next = 5;
                return this.axios.put(url, body);

              case 5:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", Result.ok(parsedResponseBody.data));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function complete(_x) {
        return _complete.apply(this, arguments);
      }

      return complete;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(parsedResponseBody.data));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return PracticeAssignmentApi;
}(AxiosApi);